import { EVENT_COLORS } from 'pages/Calendar/constants';
import { ActionTypes } from './constants';
import { State, Action } from './types';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.SET_VIEW:
      return { ...state, view: action.data };
    case ActionTypes.ADD_EVENT:
      return {
        ...state,
        events: [
          ...state.events,
          { color: EVENT_COLORS[0], ...action.data.event }
        ],
        activeEvent: action.data.ui
      };

    case ActionTypes.UPDATE_EVENT: {
      const events = [...state.events];

      const index = state.events.findIndex(item => item.id === action.data.id);

      if (index > -1) {
        events[index] = action.data;
      }

      return { ...state, events };
    }

    case ActionTypes.DELETE_EVENT:
      return {
        ...state,
        events: state.events.filter(item => item.id !== action.data)
      };
    case ActionTypes.SET_ACTIVE_EVENT:
      return { ...state, activeEvent: action.data };
    case ActionTypes.SET_EVENTS:
      return { ...state, events: [...action.data] };
    case ActionTypes.SET_APPOINTMENTS:
      return { ...state, appointments: [...action.data] };
    case ActionTypes.SET_DATES:
      return { ...state, dates: action.data };

    default:
      return state;
  }
};

export default reducer;
